import React from "react";
import { faUndo } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export default function FilterResetButton({
  label = "Filter Zurücksetzen",
  icon = faUndo,
  resetCallback,
}) {
  return (
    <button
      type="button"
      className="btn p-1 px-1 d-flex align-items-center text-primary"
      onClick={resetCallback}
    >
      <FontAwesomeIcon icon={icon} className="mr-1" />
      <span>{label}</span>
    </button>
  );
}
